import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Input, Select, message } from 'antd';
import HighSearchInput from '../../common/HighSearchInput';
import API_URL from '../../../common/url';
import { saveParams } from '../../../actions/noticeActions';

const { Option } = Select;

class Filter extends Component {
    state = {
        searchParams: {},
        invOptions: [],
    }
    
    componentDidMount() {
        const { params } = this.props;
        const { searchParams } = this.state;
        if (params.jdeMainApplyCode) {
            searchParams.jdeMainApplyCode = params.jdeMainApplyCode;
        }
        this.setState({ searchParams }, () => {
            this.search();
        });
    }
    
    componentWillUnmount() {
        const { saveParams } = this.props;
        saveParams({ jdeMainApplyCode: '' });
    }

    handleKeyPress = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    // 校验value是否存在，且是options中的一项
    validateValueInOptions = (value, name, list) => {
        if (value) {
            const isExist = list.some(item => item.value == value);
            if (!isExist) {
                message.warning(`请选择正确的${name}`);
                return true;
            }
        }
        return false;
    }

    search = () => {
        const { invOptions, searchParams } = this.state;
        const { investigationId } = searchParams;
        if (this.validateValueInOptions(investigationId, '项目简称', invOptions)) {
            return;
        }
        this.props.search(searchParams);
    }

    export = () => {
        const { searchParams } = this.state;
        this.props.export(searchParams);
    }

    handleInputChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value
        this.setState({ searchParams });
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        if (key === 'lineOfBusiness') {
            searchParams.secondLineName = undefined;
        }
        this.setState({ searchParams });
    }

    handleHighSearchInputChange = (id, options, idName, optionsName) => {
        const { searchParams } = this.state;
        searchParams[idName] = id;
        this.setState({
            searchParams,
            [optionsName]: options,
        });
    }

    render () {
        const { isAdd, businessList } = this.props;
        const { searchParams } = this.state;
        const { jdeMainApplyCode , jdeMainApplyStatus, lineOfBusiness } = searchParams;
        const { curRole, invState } = sessionStorage;
        const isPM = curRole == 'PM';
        const isTotal = invState == 1;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(i => <Option key={i}>{i}</Option>);
        return (
            <div className="filter-bar bar2">
                <div className="form-item">
                    <label className="ui-label">申请编号</label>
                    <Input placeholder="请输入" value={jdeMainApplyCode} onKeyPress={this.handleKeyPress} onChange={e => this.handleInputChange(e, 'jdeMainApplyCode')}/>
                </div>
                {
                    !isTotal &&
                    <div className="form-item">
                        <label className="ui-label">项目简称</label>
                        <HighSearchInput
                            keyword='investigationName'
                            style={{ width: 162 }}
                            placeholder="输入名称检索"
                            params={{ limit: 20, noFinished: true }}
                            url={API_URL.investigation.queryInvestigationByName}
                            config={{ id: 'investigationId', name: 'investigationName' }}
                            onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'investigationId', 'invOptions')}
                        />
                    </div>
                }
                {
                    !isTotal &&
                    <div className="form-item">
                        <label className="ui-label">申请状态</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 160}}
                            value={jdeMainApplyStatus}
                            onChange={value => this.handleSelectChange(value, 'jdeMainApplyStatus')}
                        >
                            <Option value='BO_APPROVAL_APPLY'>待BO审核</Option>
                            <Option value='BO_APPROVAL_DISAGREE'>BO审核不通过</Option>
                            <Option value='BO_APPROVAL_REJECT'>BO拒绝变更</Option>
                            <Option value='FIN_APPROVAL_APPLY'>待FIN审核</Option>
                            <Option value='FIN_APPROVAL_AGREE'>FIN审核通过</Option>
                            <Option value='FIN_APPROVAL_REJECT'>FIN拒绝变更</Option>
                            <Option value='FIN_APPROVAL_DISAGREE'>FIN审核不通过</Option>
                            <Option value='BO_MULTIPLEX_APPROVAL'>待BO复用审批</Option>
                            <Option value='BO_MULTIPLEX_APPROVAL_AGREE'>BO复用审批通过</Option>
                            <Option value='BO_MULTIPLEX_APPROVAL_DISAGREE'>BO复用审批不通过</Option>
                        </Select>
                    </div>
                }
                {
                    !isTotal &&
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">业务线</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            value={lineOfBusiness}
                            onChange={value => this.handleSelectChange(value, 'lineOfBusiness')}
                        >
                            {businessOption}
                        </Select>
                    </div>
                }
                {
                    !isTotal &&
                    <div className="form-item">
                        <label htmlFor="" className="ui-label">执行业务线二级分类</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            disabled={!lineOfBusiness}
                            value={searchParams.secondLineName}
                            onChange={value => this.handleSelectChange(value, 'secondLineName')}
                        >
                            {secondLineOption}
                        </Select>
                    </div>
                }
                <div className="form-item">
                    {
                        isTotal && isPM &&
                        (
                            isAdd ?
                                <Button type="primary" onClick={() => this.props.canEditByInvStatus(() => this.props.update())}>添加</Button>
                            :
                                <Button type="primary" disabled={true}>添加</Button>
                        )
                    }
                    { !isTotal && <Button type="primary" onClick={this.export}>导出</Button> }
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        params: state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Filter);


// WEBPACK FOOTER //
// ./src/components/contractManagement/alterJdeCode/Filter.js